import { AppError, Unauthorized } from '@/models/app-error';

const _endpoint = '/api/Accounts/';

export class AccountApi {

    constructor(client) {
        this.client = client;
    }
   
    async login(email, password) {
        try {
            const response = await this.client.post(_endpoint + 'Login', {
                email: email,
                password: password
            }, { 
                anonymous: true
            });     
                        
            return {
                token: response
            };

        } catch (error) {
            if (error instanceof AppError && error.isHttpError(Unauthorized)) {
                error.message = 'Incorrect email or password.';
            }                

            throw error;
        }      
    }

    async getCustomerName(id) {
        try {
            var response = await this.client.get('/api/Customers/' + id); 
            return response.name;  
        } catch (error) {
            if (error instanceof AppError && error.isHttpError(Unauthorized)) {
                error.message = 'Unauthorized request.';
            }

            throw error;
        }  
    } 

    async changePassword(email, currentPassword, newPassword) {
        try {
            await this.client.post(_endpoint + 'ChangePassword', {
                email: email,
                oldPassword: currentPassword,
                newPassword: newPassword,
                confirmPassword: newPassword
            });   
        } catch (error) {
            if (error instanceof AppError && error.isHttpError(Unauthorized)) {
                error.message = 'Unauthorized request.';
            }

            throw error;
        }  
    } 

    async remindPassword(email) {
        try {
            const response = await this.client.post(_endpoint + 'ForgotPassword', {
                email: email
            });   

            return response;

        } catch (error) {
            if (error instanceof AppError && error.isHttpError(Unauthorized)) {
                error.message = 'Unauthorized request.';
            }           
            
            throw error;
        } 
    } 

    async deactivateAccount() {

        try {
            const response = await this.client.post(_endpoint + 'Deactivate');   
            return response;

        } catch (error) {

            if (error instanceof AppError && error.isHttpError(Unauthorized)) {
                error.message = 'Unauthorized request.';
            } 

            throw error;
        }

    }

    async resetPassword(newPassword, confirmPassword, token){

        try {
            const response = await this.client.post(_endpoint + 'ResetPassword', {
                token: decodeURIComponent(token),
                newPassword: newPassword,
                confirmPassword: confirmPassword
            }, { 
                anonymous: true
            });             
            return response;

        } catch (error) {          
            if (error instanceof AppError && error.isHttpError(Unauthorized)) {
                error.message = 'Unauthorized request.';
            } 
            throw error;
        } 
    }
}